import KeyedItem from "../base/item";
import Tag from "../tag/tag";

type Prompt = KeyedItem & {
  title: string;
  description: string;
  promptString: string;
  tags: Tag[];
  likes: string[];
  dislikes: string[];
  favorites: string[];
  uses: number;
  status: PromptStatus;
  promptRating: number;
  userId: string;
};

export enum PromptStatus {
  Personal = "Personal",
  Pending = "Pending",
  Accepted = "Accepted",
  Rejected = "Rejected",
}

export enum PromptRating {
  DownVote = -1,
  NeutralVote = 0,
  UpVote = 1,
}

export default Prompt;
